import styled from "styled-components";

export const Style = styled.div`
  .mediaWrap {
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    bottom: 0;
    z-index: 100;
  }

  .adverBackground {
    width: 100%;
    height: 65vh;
    overflow: hidden;
    position: relative;
    background: #000;
  }
  .imgContainer {
    display: flex;
    transition: transform 0.5s ease-in-out;
    transform: translateX(-100%);
  }
  .imageBox {
    width: 100%;
    min-width: 100%;
    box-sizing: border-box;
    div {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .slideBtn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 99;
  }

  .left {
    left: 3%;
  }

  .right {
    right: 3%;
  }

  /* 버튼 스타일 */
  .prevEventButton,
  .nextEventButton,
  .closeButton {
    position: absolute;
    z-index: 101;
  }
  .prevEventButton {
    left: 3%;
    bottom: 30%;
  }
  .nextEventButton {
    right: 3%;
    bottom: 30%;
  }
  .closeButton {
    display: flex;
    align-items: center;
    justify-content: space-between;
    right: 3%;
    margin-top: 21px;
    padding: 4px 9px 4px 16px;
    gap: 5px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 50px;
    p {
      font-size: 18px;
      font-weight: 400;
      color: #fff;
    }
  }
  .eventPageWrap {
    width: 100vw;
    height: 65vh;
  }
  iframe {
    min-height: 65vh;
    border: none;
  }

  /* adverStoreWrap */
  .adverStoreWrap {
    position: relative;
  }
  .storeName {
    position: absolute;
    top: 21px;
    left: 41px;
    padding: 8px 30px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 5px;

    h2 {
      font-size: 24px;
      font-weight: 400;
    }
  }

  .adVideo,
  .adImg {
    width: 100vw;
    height: 65vh;
    background: #000;
    object-fit: contain;
  }

  .movement {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: space-between;

    background: rgba(255, 255, 255, 0.6);
    border-radius: 50px;
    gap: 12px;

    h3 {
      font-size: 18px;
      font-weight: 400;
      line-height: 30px;
      color: #262626;
    }
  }
  .movement.store {
    right: 3%;
    bottom: 15%;
    padding: 9px 20px;
    min-width: 185px;
    h3 {
      width: 100%;
      text-align: center;
    }
  }
  .movement.event {
    right: 3%;
    bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    text-align: center;
    padding: 4px 16px;
    background: #ffeef7;
    z-index: 101;
  }
  .eventText {
    h3,
    h4 {
      font-family: "yg-jalnan";
      color: #ff1d79;
      font-weight: 400;
    }
    h3 {
      font-size: 18px;
      line-height: 30px;
    }
    h4 {
      padding-top: 5px;
      font-size: 14px;
    }
  }
`;
